import * as yup from "yup";
import { Formik } from "formik";
import { useEffect, useRef, useState } from "react";
import { Icon } from "@iconify/react";
import { Button } from "../../../../components/ui/button";
import Common from "../../../../helper/common";
import { FormikInput, FormikSwitch } from "../../../../components/formik-components";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "../../../../components/ui/dialog";
import { useNavigate } from "react-router-dom";
import { respEnum } from "../../../../constants/appConstant";

const FormikInitialValues = {
  name: "",
  code: "",
  isactive: true,
};

const formikValidation = yup.object({
  name: yup.string().required("Name is required"),
  code: yup.string().nullable(),
});

const AddPOSMachine = ({ id, onClose, open, setOpen }) => {
  const formikRef = useRef();
  const dialogRef = useRef();
  const navigate = useNavigate();
  const [isFormikInitialized, setIsFormikInitialized] = useState(false);

  useEffect(() => {
    setIsFormikInitialized(open);
  }, [open]);

  const onSubmitData = async (d, action) => {
    let data = {
      ...d,
      id,
    };
    let response = await Common.ApiService.getInstance().request(
      "AddUpdatePOSMachine",
      data,
      "POST"
    );
    action.setSubmitting(false);
    if (response.status === respEnum.Success) {
      onClose?.(response.data);
      setOpen(false);
      if (!onClose) {
        navigate("/app/posmachines", { replace: true });
      }
    }
  };

  const getDataInfo = async () => {
    const payload = { pageNumber: 1, recordsToDisplay: 1000 };
    let response = await Common.ApiService.getInstance().request(
      "GetPOSMachines",
      payload,
      "POST"
    );
    if (Array.isArray(response?.data) && response.data.length > 0) {
      const list = response.data[0]?.data ?? [];
      const current = list.find((x) => x.id === id);
      if (current) {
        formikRef.current.setValues({
          name: current.name,
          code: current.code,
          isactive: current.isactive,
        });
      }
    }
  };

  useEffect(() => {
    if (id) {
      getDataInfo();
    }
  }, [id]);

  return (
    <div>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogTrigger asChild>
          <Button
            size="sm"
            variant="primary"
            className="flex items-center gap-2"
          >
            <Icon icon="heroicons:plus-20-solid" className="h-4 w-4" />
            Add
          </Button>
        </DialogTrigger>
        <DialogContent
          ref={dialogRef}
          className="max-h-[100vh] overflow-y-auto sm:max-w-[500px]"
        >
          <DialogHeader>
            <DialogTitle className="text-base font-medium">
              {!id ? "Add" : "Update"} POS Machine
            </DialogTitle>
          </DialogHeader>

          <div className="text-sm text-default-500 space-y-2">
            <Formik
              innerRef={formikRef}
              onSubmit={onSubmitData}
              initialValues={FormikInitialValues}
              validationSchema={formikValidation}
              validateOnChange={false}
              validateOnBlur={false}
            >
              {(formikProps) => (
                <div className="flex flex-col gap-4">
                  <FormikInput
                    formikProps={formikProps}
                    name={"name"}
                    label={"Name"}
                    placeholder={"Enter POS Machine Name"}
                  />

                  <FormikInput
                    formikProps={formikProps}
                    name={"code"}
                    label={"Code"}
                    placeholder={"Enter Code (optional)"}
                  />

                  <FormikSwitch
                    formikProps={formikProps}
                    name={"isactive"}
                    label={"Active"}
                  />
                </div>
              )}
            </Formik>
          </div>

          <DialogFooter className="mt-6">
            <DialogClose asChild>
              <Button type="button" variant="outline">
                Close
              </Button>
            </DialogClose>
            {isFormikInitialized && formikRef.current && (
              <Button
                type="button"
                onClick={(e) => {
                  e.preventDefault();
                  formikRef.current?.handleSubmit();
                }}
              >
                {formikRef.current.isSubmitting
                  ? "Saving..."
                  : !id
                  ? "Add"
                  : "Update"}
              </Button>
            )}
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default AddPOSMachine;


